import React from "react";
import { NavLink } from "react-router-dom";

function Navbar() {
  return (
    <header className="nav-wrapper">
      <nav className="nav">
        <div className="nav-brand">
          <span className="nav-brand-script">Mr. and Mrs. Cephas</span>
        </div>
        <div className="nav-links">
          <NavLink to="/" className="nav-link">
            Home
          </NavLink>
          <NavLink to="/details" className="nav-link">
            Wedding Details
          </NavLink>
          <NavLink to="/rsvp" className="nav-link">
            RSVP
          </NavLink>
          <NavLink to="/gallery" className="nav-link">
            Gallery
          </NavLink>
          <NavLink to="/faq" className="nav-link">
            FAQ
          </NavLink>
        </div>
      </nav>
    </header>
  );
}

export default Navbar;